var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAtsign(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 503.576,
    height: 498.94,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M11.73 32.129h571.688v518.65H11.73z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "b",
    d: "M11.73 32.129h571.688v518.65H11.73z"
  }))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontWeight: 400,
      fontSize: 40,
      lineHeight: 1.25,
      fontFamily: "sans-serif",
      letterSpacing: 0,
      wordSpacing: 0,
      whiteSpace: "pre",
      shapeInside: "url(#a)",
      display: "inline",
      fill: "#1bf54f",
      fillOpacity: 1,
      stroke: "none"
    },
    transform: "matrix(1.86644 0 0 1.8024 -35.6 -232.43)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 11.73,
    y: 401.672
  }, /*#__PURE__*/React.createElement("tspan", {
    style: {
      fontStretch: "extra-condensed",
      fontSize: 400,
      fontFamily: "Algerian",
      InkscapeFontSpecification: "&quot"
    }
  }, "@"))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontWeight: 400,
      fontSize: 40,
      lineHeight: 1.25,
      fontFamily: "sans-serif",
      letterSpacing: 0,
      wordSpacing: 0,
      whiteSpace: "pre",
      shapeInside: "url(#b)",
      display: "inline",
      fill: "#000",
      fillOpacity: 1,
      stroke: "none"
    },
    transform: "matrix(1.86644 0 0 1.8024 -39.392 -236.412)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 11.73,
    y: 401.672
  }, /*#__PURE__*/React.createElement("tspan", {
    style: {
      fontStretch: "extra-condensed",
      fontSize: 400,
      fontFamily: "Algerian",
      InkscapeFontSpecification: "&quot"
    }
  }, "@"))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtsign);
export default __webpack_public_path__ + "static/media/atsign.7d7145160e750b210b72c6e00f01c14f.svg";
export { ForwardRef as ReactComponent };